/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiDriveType,
    ApiDriveTypeFromJSON,
    ApiDriveTypeFromJSONTyped,
    ApiDriveTypeToJSON,
} from './';

/**
 * Vehicle details
 * @export
 * @interface ApiVehicleDetails
 */
export interface ApiVehicleDetails {
    /**
     * 
     * @type {string}
     * @memberof ApiVehicleDetails
     */
    licensePlate: string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehicleDetails
     */
    vinCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehicleDetails
     */
    mark: string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehicleDetails
     */
    model: string;
    /**
     * 
     * @type {number}
     * @memberof ApiVehicleDetails
     */
    year?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiVehicleDetails
     */
    transmissionType?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiVehicleDetails
     */
    weightKg?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiVehicleDetails
     */
    bodyType?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiVehicleDetails
     */
    color?: string;
    /**
     * 
     * @type {ApiDriveType}
     * @memberof ApiVehicleDetails
     */
    driveType?: ApiDriveType;
}

export function ApiVehicleDetailsFromJSON(json: any): ApiVehicleDetails {
    return ApiVehicleDetailsFromJSONTyped(json, false);
}

export function ApiVehicleDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiVehicleDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'licensePlate': json['licensePlate'],
        'vinCode': !exists(json, 'vinCode') ? undefined : json['vinCode'],
        'mark': json['mark'],
        'model': json['model'],
        'year': !exists(json, 'year') ? undefined : json['year'],
        'transmissionType': !exists(json, 'transmissionType') ? undefined : json['transmissionType'],
        'weightKg': !exists(json, 'weightKg') ? undefined : json['weightKg'],
        'bodyType': !exists(json, 'bodyType') ? undefined : json['bodyType'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'driveType': !exists(json, 'driveType') ? undefined : ApiDriveTypeFromJSON(json['driveType']),
    };
}

export function ApiVehicleDetailsToJSON(value?: ApiVehicleDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'licensePlate': value.licensePlate,
        'vinCode': value.vinCode,
        'mark': value.mark,
        'model': value.model,
        'year': value.year,
        'transmissionType': value.transmissionType,
        'weightKg': value.weightKg,
        'bodyType': value.bodyType,
        'color': value.color,
        'driveType': ApiDriveTypeToJSON(value.driveType),
    };
}

